import { useState, useEffect } from "react";
import { Calendar, Clock, MapPin, Users } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

const details = [
  {
    icon: Calendar,
    overline: "Date",
    title: "Monday, 27 April",
    sub: "2026",
    testid: "event-date-card",
  },
  {
    icon: Clock,
    overline: "Time",
    title: "10:00 AM – 1:00 PM",
    sub: "Indian Standard Time",
    testid: "event-time-card",
  },
  {
    icon: MapPin,
    overline: "Venue",
    title: "DoubleTree by Hilton",
    sub: "Ahmedabad, Gujarat, India",
    testid: "event-venue-card",
  },
];

export default function EventDetails() {
  const [seats, setSeats] = useState({ remaining: 50, registered: 0 });

  useEffect(() => {
    fetch(`${BACKEND_URL}/api/seats-remaining`)
      .then((r) => r.json())
      .then((d) => setSeats(d))
      .catch(() => {});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // BACKEND_URL is a build-time constant; intentionally omitted

  const pct = Math.round((seats.registered / 50) * 100);

  return (
    <section id="event-details" data-testid="event-details-section" className="section-charcoal py-24 lg:py-32 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <p className="overline-gold mb-3">Event Information</p>
          <h2 className="font-['Cormorant_Garamond'] text-3xl lg:text-4xl text-white font-medium">
            Mark Your Calendar
          </h2>
          <div className="gold-divider w-40 mx-auto mt-5" />
        </div>

        {/* Detail cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          {details.map(({ icon: Icon, overline, title, sub, testid }) => (
            <div key={testid} data-testid={testid} className="glass-card p-8 flex flex-col items-center text-center gap-4">
              <div className="w-12 h-12 bg-[#D4AF37]/10 border border-[#D4AF37]/25 flex items-center justify-center">
                <Icon size={22} className="text-[#D4AF37]" />
              </div>
              <div>
                <p className="overline-gold text-[0.62rem] mb-1">{overline}</p>
                <p className="font-['Cormorant_Garamond'] text-xl text-white font-medium">{title}</p>
                <p className="text-[#94A3B8] text-xs mt-1 font-['Outfit']">{sub}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Seats remaining */}
        <div data-testid="seats-remaining-card" className="glass-card p-8 max-w-xl mx-auto text-center">
          <div className="flex items-center justify-center gap-3 mb-4">
            <Users size={18} className="text-[#D4AF37]" />
            <p className="overline-gold text-[0.7rem]">Capacity — Strictly Limited</p>
          </div>
          <p className="font-['Cormorant_Garamond'] text-4xl text-[#D4AF37] font-semibold">
            {seats.remaining}
            <span className="text-[#94A3B8] text-xl font-light"> / 50 Seats</span>
          </p>
          <p className="text-[#94A3B8] text-xs mt-2 font-['Outfit']">Remaining available invitations</p>
          {/* Progress bar */}
          <div className="mt-5 h-1 bg-[#0A1128] w-full">
            <div
              data-testid="seats-progress-bar"
              className="h-full bg-gradient-to-r from-[#D4AF37] to-[#E8C84A] transition-all duration-700"
              style={{ width: `${pct}%` }}
            />
          </div>
          <p className="text-[#D4AF37]/60 text-[0.65rem] mt-2 font-['Outfit'] tracking-wider uppercase">
            {pct}% Capacity Filled
          </p>
        </div>
      </div>
    </section>
  );
}
